"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromiseSimpleEventList = void 0;
const ste_core_1 = require("ste-core");
const PromiseSimpleEventDispatcher_1 = require("./PromiseSimpleEventDispatcher");
/**
 * Storage class for multiple simple events that are accessible by name.
 * Events dispatchers are automatically created.
 */
class PromiseSimpleEventList extends ste_core_1.EventListBase {
    /**
     * Creates a new SimpleEventList instance.
     */
    constructor() {
        super();
    }
    /**
     * Creates a new dispatcher instance.
     */
    createDispatcher() {
        return new PromiseSimpleEventDispatcher_1.PromiseSimpleEventDispatcher();
    }
}
exports.PromiseSimpleEventList = PromiseSimpleEventList;
